import React from "react";

export const CategoryTwo = () => <h1>CategoryTwo</h1>
